// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-snackbar {
  min-width: auto;
  max-width: none;
  color: var(--white);
  padding: 1.2rem 1.8rem;
  border-radius: 0.8rem;
  box-shadow: 0 1.6rem 3.2rem rgba(97, 97, 97, 0.1), 0 0.8rem 1.6rem rgba(97, 97, 97, 0.2);
}
.app-snackbar.success {
  background-color: var(--green);
}
.app-snackbar.error {
  background-color: var(--red);
}
.app-snackbar app-snackbar {
  display: flex;
  align-items: center;
  gap: 1.2rem;
}
.app-snackbar .text {
  font-size: 1.4rem;
  line-height: 2.4rem;
  white-space: nowrap;
  margin: 0;
}
.app-snackbar i {
  font-size: 1.8rem;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/shared/snackbar/snackbar.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,wFACE;AAAJ;AAGE;EACE,8BAAA;AADJ;AAIE;EACE,4BAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAHJ;AAME;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAJJ;AAOE;EACE,iBAAA;EACA,eAAA;AALJ","sourcesContent":[".app-snackbar {\n  min-width: auto;\n  max-width: none;\n  color: var(--white);\n  padding: 1.2rem 1.8rem;\n  border-radius: 0.8rem;\n  box-shadow:\n    0 1.6rem 3.2rem rgba(97, 97, 97, 0.1),\n    0 0.8rem 1.6rem rgba(97, 97, 97, 0.2);\n\n  &.success {\n    background-color: var(--green);\n  }\n\n  &.error {\n    background-color: var(--red);\n  }\n\n  & app-snackbar {\n    display: flex;\n    align-items: center;\n    gap: 1.2rem;\n  }\n\n  & .text {\n    font-size: 1.4rem;\n    line-height: 2.4rem;\n    white-space: nowrap;\n    margin: 0;\n  }\n\n  & i {\n    font-size: 1.8rem;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
